/**
 * Created by mac on 9/21/23
 */

const aisensia = {};

cleverapps.whenAllInitialized(
    () => {
        if (cleverapps.config.debugMode) {
            MedalCollectionTool.init();
            cleverapps.flags.statsShow = true;
        }

        aisensia.initialized = true;
    }
);

// Diagnostics: on a corrupted-data conflict, report which snapshot keys differ
// between local and server (helps find what in localStorage got broken).
cleverapps.initSynchronizer = cleverapps.extendFunc(cleverapps.initSynchronizer, function (done) {
    connector.synchronizer.on("checkSession:conflict", () => {
        if (!connector.synchronizer.corrupted) {
            return;
        }

        if (!["arrowsaway", "tapaway"].includes(cleverapps.config.name)) {
            return;
        }

        const data = connector.synchronizer.conflictData || {};
        const local = data.localSnapshot || {};
        const remote = data.remoteSnapshot || {};

        const stringify = (value) => {
            const str = JSON.stringify(value);
            return str && str.length > 300 ? `${str.substring(0, 300)}...` : str;
        };

        const empty = (v) => v === undefined || v === null || v === ""
            || typeof v === "object" && Object.keys(v).length === 0
            || Array.isArray(v) && v.length === 0;

        const equals = (a, b) => {
            if (empty(a) && empty(b)) {
                return true;
            }
            if (empty(a) || empty(b)) {
                return false;
            }
            return JSON.stringify(a) === JSON.stringify(b);
        };

        const diff = Object.keys({ ...local, ...remote })
            .filter((key) => !equals(local[key], remote[key]))
            .map((key) => `${key}: local=${stringify(local[key])} server=${stringify(remote[key])}`)
            .join(" | ");

        cleverapps.throwAsync({ group: "corrupted", message: `diff ${diff}` });
    });

    this._super(done);
});

cleverapps.createGlobalObjects = cleverapps.extendFunc(cleverapps.createGlobalObjects, function () {
    cleverapps.config.persons = cleverapps.config.persons || {};

    const res = this._super();

    if (typeof MiniGameToolbarItem !== "undefined") {
        cleverapps.toolbar.addItem(new MiniGameToolbarItem());
    }

    if (typeof GalleryToolbarItem !== "undefined") {
        cleverapps.toolbar.addItem(new GalleryToolbarItem());
    }

    return res;
});

if (cleverapps.config.name === "yatzy" && cleverapps.Lives) {
    cleverapps.Lives.TIMEOUT = cleverapps.parseInterval(cleverapps.config.debugMode ? "5 minute" : "30 minutes");
}
